'use strict';

/*globals isEmpty*/
/*globals services*/
/*globals Handsontable*/

function WinsHandsontable($container, setting) {
    this.$container = $container;

    this.defaultSetting = {};
    this.setting = setting;
    this.handsontable = null;

    this.errors = [];

    this.init();
}

WinsHandsontable.prototype = $.extend({}, {
    construtor: 'WinsHandsontable', 
    
    //**************************************************************************

    isEmptyRowData: function isEmptyRowData(rowData) {
        var empty = true;
        $.each(rowData, function (key, value) {
            if (!isEmpty(value)) {
                empty = false;
                return false;
            }
        });

        return empty;
    },

    getData: function getData() {
        var _this = this;

        var data = [];
        $.each(_this.handsontable.getData(), function (rowIndex, row) {
            var rowData = {};
            $.each(row, function (colIndex, col) {
                rowData[_this.setting.columns[colIndex].data] = col;
            });

            if (!_this.isEmptyRowData(rowData)) {
                data.push(rowData);
            }
        });

        return data;
    },

    getColumnIndex: function getColumnIndex(col) {
        var _this = this;

        var index = 0;
        for (var column in _this.setting.columns) {
            if (column in _this.setting.columns) {
                if (_this.setting.columns[column].data === col) {
                    break;
                }

                index++;
            }
        }

        return index;
    },

    setData: function setData(data) {
        var _this = this;

        $.each(data, function (rowIndex, row) {
            for (var column in row) {
                if (column in row) {
                    var colIndex = _this.getColumnIndex(column);                    
                    var value = row[column];

                    _this.handsontable.setDataAtCell(rowIndex, colIndex, value);
                }
            }
        });

        return _this;
    },

    setErrors: function setErrors(errors) {
        var _this = this;

        _this.errors = errors;
        if (_this.errors) {
            var hasErrors = false;

            for (var row in _this.errors) {
                if (row in _this.errors) {
                    for (var col in _this.errors[row]) {
                        if (col in _this.errors[row]) {
                            if (_this.errors[row][col]) {
                                _this.handsontable.setCellMeta(row, _this.getColumnIndex(col), 'valid', false);
                                hasErrors = true;
                            }
                        }
                    }
                }
            }

            if (hasErrors) {
                _this.handsontable.render();
            }
        }

        return _this;
    },

    destroy: function destroy() {
        var _this = this;
        
        _this.handsontable.destroy();
    },

    //**************************************************************************

    getDateFormatSetting: function getDateFormatSetting() {
        var _this = this;

        var setting = {
            dateFormat: services.get('translator').trans('Local_date_format_handsontable'),
            correctFormat: false,
            defaultDate: services.get('translator').trans('CurrentDate'),
            datePickerConfig: {
                firstDay: 1,
                i18n: {
                    previousMonth: services.get('translator').trans('PrevMonth'),
                    nextMonth: services.get('translator').trans('NextMonth'),
                    months: [services.get('translator').trans('Month01'), services.get('translator').trans('Month02'), services.get('translator').trans('Month03'), services.get('translator').trans('Month04'), services.get('translator').trans('Month05'), services.get('translator').trans('Month06'), services.get('translator').trans('Month07'), services.get('translator').trans('Month08'), services.get('translator').trans('Month09'), services.get('translator').trans('Month10'), services.get('translator').trans('Month11'), services.get('translator').trans('Month12')],
                    weekdays: [services.get('translator').trans('Sunday'), services.get('translator').trans('Monday'), services.get('translator').trans('Tuesday'), services.get('translator').trans('Wednesday'), services.get('translator').trans('Thursday'), services.get('translator').trans('Friday'), services.get('translator').trans('Saturday')],
                    weekdaysShort: [services.get('translator').trans('Sun'), services.get('translator').trans('Mon'), services.get('translator').trans('Tue'), services.get('translator').trans('Wed'), services.get('translator').trans('Thu'), services.get('translator').trans('Fri'), services.get('translator').trans('Sat')]
                }
            }
        };

        return setting;
    },

    initDefualtSetting: function initDefualtSetting() {
        var _this = this;

        _this.defaultSetting = {
            data: [],
            columns: [],
            stretchH: 'all', 
            colHeaders: true,
            rowHeaders: true,
            contextMenu: true,
            filters: true,
            dropdownMenu: true,
            minSpareRows: 6
        };

        return _this;
    },

    initHandsontable: function initHandsontable() {
        var _this = this;

        _this.handsontable = new Handsontable(_this.$container.get(0), _this.setting);

        return _this;
    },

    updateSetting: function updateSetting(setting) {
        var _this = this;

        if (!_this.setting.colHeaders.length) {
            if (_this.setting.columns.length) {
                _this.setting.colHeaders = [];
                $.each(_this.setting.columns, function (key, column) {
                   if ('title' in column) {
                        _this.setting.colHeaders.push(column.title);
                   } 
                });
            }
        }

        if (_this.setting.columns.length) {
            for (var columnId in _this.setting.columns) {
                if (columnId in _this.setting.columns) {
                    if ('type' in _this.setting.columns[columnId] && _this.setting.columns[columnId].type === 'date') {
                        _this.setting.columns[columnId] = $.extend({}, _this.getDateFormatSetting(), _this.setting.columns[columnId]);
                    }
                }
            }
        }

        return setting;
    },

    //**************************************************************************    

    init: function init() {
        var _this = this;

        _this.initDefualtSetting();
        _this.setting = $.extend({}, _this.defaultSetting, _this.setting);
        _this.updateSetting(_this.setting);
        _this.initHandsontable();

        return _this;
    }
});
